import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { apiClient } from "@/lib/apiClient";

export default function CipherActivity() {
  const { data, isLoading } = useQuery({
    queryKey: ["ciphers"],
    queryFn: () => apiClient.listCiphers({ limit: 100 }),
  });

  const stats = useMemo(() => {
    const ciphers = data?.ciphers ?? [];
    const active = ciphers.filter((c) => c.status === "active");
    return {
      active: active.length,
      basic: active.filter((c) => c.security_level === "basic").length,
      protected: active.filter((c) => c.security_level === "standard").length,
      verified: active.filter((c) => c.security_level === "advanced").length,
    };
  }, [data]);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Cipher Activity</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col items-center justify-center">
        {isLoading ? (
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
        ) : (
          <>
            <div className="text-center">
              <p className="text-sm text-muted-foreground mb-2">
                Active Ciphers
              </p>
              <p className="text-4xl font-bold text-emerald-600">
                {stats.active}
              </p>
            </div>
            <div className="grid grid-cols-3 gap-4 w-full text-center mt-6 text-sm">
              <div>
                <p className="text-muted-foreground">Basic</p>
                <p className="text-lg font-semibold text-emerald-600">
                  {stats.basic}
                </p>
              </div>
              <div>
                <p className="text-muted-foreground">Protected</p>
                <p className="text-lg font-semibold text-indigo-600">
                  {stats.protected}
                </p>
              </div>
              <div>
                <p className="text-muted-foreground">Verified</p>
                <p className="text-lg font-semibold text-purple-600">
                  {stats.verified}
                </p>
              </div>
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
}
